import React from "react"
import {
    menuCreateItem,
    justifyContents,
    contextMenuOff,
    filterHandler,
    removeSearchParameter,
    showAll,
    objectLang,
    setPathBack,
    getPathAndQueryParams,
    getRandomKey,
    removeCookieOfFolderId, getPathBack, removeLocalStorageItem,
} from "../functions"
import folderIcon from "../images/full-folder.png"
import folderIconEmpty from "../images/empty-folder.png"
import folderPublicIcon from "../images/public-full-folder.png"
import folderPublicEmptyIcon from "../images/public-empty-folder.png"
import googleFolderIcon from "../images/full-folder.png"
import googleFolderIconEmpty from "../images/empty-folder.png"
import googleFolderPublicIcon from "../images/public-full-folder.png"
import googleFolderPublicEmptyIcon from "../images/public-empty-folder.png"
import img_context_menu from "../images/context-menu.png"
import img_context_menu_google from "../images/context-menu.png"
import Row from 'react-bootstrap/Row'
import {FolderPage} from "../pages/FolderPage"
import {MenuCreateItemPage} from "../elements/MenuCreateItemPage"
import config from "../config.json"
import {GoogleFolderElement} from "../elements/GoogleFolderElement"
import {FolderElement} from "../elements/FolderElement"
import {LinkElement} from "../elements/LinkElement"
import {NoteElement} from "../elements/NoteElement"
import {GoogleFileElement} from "../elements/GoogleFileElement"
import {LoaderClass} from "../elements/LoaderClass"
import {Link} from "react-router-dom"

export class LinksClass extends React.Component {

    render() {

        let {
            auth,
            documents,
            items,
            rootFolder,
            loadMore,
            pageToken,
            setCountItems,
            countItems,
            thumbnails = {},
            linksView = {},
            clearTrashHandler
        } = this.props

        if (!documents) {
            return (
                <LoaderClass/>
            )
        }

        if (!auth) {
            auth = {
                userId: undefined,
                isAuthenticated: false,
                owner: undefined
            }
        }

        let owner = auth.userId
        if (owner && owner === '64648579d6767031d41bd359') {
            owner = 'trial-user'
        }

        const lang = objectLang().language
        const l = lang.lang
        if (!documents.opening) {
            documents.opening = 'open'
        }

        const isGoogleDisc = window.location.pathname.includes('google-drive/open')
        const isTrash = !window.location.pathname.includes('google-drive/open/trash')
        const isFolders = isTrash ? !isGoogleDisc : isGoogleDisc
        if (!isTrash) {
            removeLocalStorageItem('trash')
        }

        let folderImgFull = folderIcon,
            folderImgEmpty = folderIconEmpty,
            googleFolderImgFull = googleFolderIcon,
            googleFolderImgEmpty = googleFolderIconEmpty
        if (documents.opening === 'open-public' || documents.opening === 'open-share') {
            folderImgFull = folderPublicIcon
            folderImgEmpty = folderPublicEmptyIcon
        }
        const urlParams = new URLSearchParams(window.location.search)
        let textFilter = urlParams.get('filter')

        if (!documents) {
            return (
                <FolderPage/>
            )
        }

        if (documents.parent) {
            if (documents.opening === 'open-public' && documents.parent === rootFolder) {
                setPathBack(`/${l}/folder/open-public/${config.trialRootFolderId}`)
            } else if (documents.opening === 'open-public' && documents.parent !== rootFolder) {
                setPathBack(`/${l}/folder/open-public/${documents.parent}`)
            } else {
                if (!window.location.pathname.includes(`/google-drive/open/trash`)) {
                    if (documents.parent === 'root' || documents.parent.length === 33 || documents.parent.length === 19) {
                        setPathBack(`/${l}/google-drive/open/${documents.parent}`)
                    } else {
                        setPathBack(`/${l}/folder/open/${documents.parent}`)
                    }
                }
            }
        }

        if (textFilter && documents) {
            if (textFilter === '*') {
                textFilter = ''
            }
            setTimeout(() => {
                setCountItems(filterHandler(textFilter, documents, items.length))
            }, 200)
        }

        let name = documents.name,
            rootPublicLinks = lang.body.myLinksPage.titlePublicLinks,
            rootMyLinks = lang.body.myLinksPage.title,
            rootGoogleDrive = lang.body.googleDrivePage.title

        if (!documents.parent) {
            documents.parent = 'root'
        }
        if (documents.opening !== 'open-public') {
            if ((documents.name === 'Root-public' || documents.name === 'root-public')) {
                name = rootPublicLinks
            } else if (!documents.name || documents.name === 'Root' || documents.name === 'root') {
                name = rootMyLinks
            } else if (documents.parent.length === 19 || documents.parent === 'root') {
                name = rootGoogleDrive
            }
        }

        return (
            <>
                <div onClick={contextMenuOff}
                     id={"main-container"}
                     className={"m-0-auto p-4 pt-0 container"}>
                    <div className={"title-body"}>
                        {/* Название папки */}
                        <Row id={"row-title"} xs={1} className={"d-flex justify-content-center m-0"}>
                            <div id={"title"} className={"p-0 mt-1 text-center"}>
                                <div id={'title-page'}
                                     className={"border-primary rounded mt-2 mb-3 d-flex justify-content-center align-items-baseline"}>

                                    {/* "Корзина Google Диска" */}
                                    {isGoogleDisc && isTrash && <div className={'btn btn-light me-2'}>
                                        <Link to={`/${lang.lang}/google-drive/open/trash`}
                                              title={lang.body.googleDrivePage.trash}>
                                            <div className={'text-decoration-none text-secondary fs-6 ps-2 pe-2'}>
                                                <i className={`fa-regular fa-trash-can`}/>
                                            </div>
                                        </Link>
                                    </div>}

                                    {/* "Google Диск" */}
                                    {isGoogleDisc && isFolders && <div className={'btn btn-light me-2'}>
                                        <Link to={''} title={lang.body.googleDrivePage.foldersAndFiles}
                                              onClick={() => {
                                                  window.location.replace(getPathBack())
                                              }}>
                                            <div className={'text-decoration-none text-secondary fs-6 ps-2 pe-2'}>
                                                <i className={`fa-solid fa-folder-open`}/>
                                            </div>
                                        </Link>
                                    </div>}

                                    {/* "обновить текущую папку" */}
                                    <div className={'btn btn-light me-2'}>
                                        <div className={'text-decoration-none text-secondary fs-6 ps-2 pe-2'}>
                                            <i className={`fa-solid fa-arrows-rotate`}
                                               onClick={() => {
                                                   removeCookieOfFolderId(documents.parent)
                                                   window.location.replace(getPathAndQueryParams())
                                               }}/>
                                        </div>
                                    </div>

                                    <h2 id={"title-text"}
                                        className={"text-success mb-0 text-decoration-none me-2"}>
                                        {name}
                                    </h2>

                                    {/* "Создать элемент" */}
                                    <div className={"d-flex"}>
                                        <Link to={"#"} className={"btn btn-light me-2 fs-6"}
                                              onClick={(e) => {
                                                  if (documents.opening === 'open') {
                                                      menuCreateItem(e)
                                                  }
                                              }}>
                                            <i className="fa-solid fa-ellipsis-vertical text-secondary fs-6 px-2"
                                               style={{pointerEvents: 'none'}}
                                            />
                                        </Link>
                                    </div>

                                    {/* "Фото Google Диска" */}
                                    {!isTrash && <div className={'btn btn-light me-2'}>
                                        <Link to={''} title={lang.body.googleDrivePage.clearTrash}
                                              onClick={clearTrashHandler}>
                                            <div className={'text-decoration-none text-secondary fs-6 ps-2 pe-2'}>
                                                <i className={`fa-solid fa-broom`}/>
                                            </div>
                                        </Link>
                                    </div>}

                                    {/* "Фото Google Диска" */}
                                    {/*{isGoogleDisc && <div className={'btn btn-light me-2'}>*/}
                                    {/*    <Link to={`/${lang.lang}/google-drive/open/google-photo`} title={'Google Фото'}>*/}
                                    {/*        <div className={'text-decoration-none text-secondary fs-6 ps-2 pe-2'}>*/}
                                    {/*            <i className={`fa-regular fa-image`}/>*/}
                                    {/*        </div>*/}
                                    {/*    </Link>*/}
                                    {/*</div>}*/}

                                </div>
                                <div
                                    className="border-primary rounded mt-2 mb-3 me-2 d-flex align-items-center justify-content-center">
                                    <div
                                        className={'border-1 rounded-3 d-flex align-items-center justify-content-center ps-2 pe-2'}>
                                        <p style={{lineHeight: "1.2"}}
                                           className={'m-auto'}>{`${countItems} ${lang.body.foldersPage.pieces}`}</p>
                                    </div>

                                    <input
                                        autoComplete="off"
                                        id="filterInput"
                                        className="form-control me-1 ms-1"
                                        type="search"
                                        placeholder={lang.body.foldersPage.filterName}
                                        aria-label="Filter"
                                        defaultValue={textFilter}
                                        onChange={(e) => {
                                            removeSearchParameter()
                                            showAll()
                                            setCountItems(filterHandler(e.target.value, documents, items.length))
                                        }}
                                        style={{
                                            marginBottom: 0, // чтобы не смещался вниз
                                        }}
                                    />
                                </div>

                            </div>
                        </Row>
                    </div>

                    <div id={'body-items'}
                         className={`body-items d-flex ${justifyContents(items).body_items_justify}`}>
                        <div id={"row-items"} className={`d-flex ${justifyContents(items).row_items_justify}`}
                             style={{width: `${justifyContents(items).scrollWidth}px`}}>
                            <Row id={'items'} xs={2} md={4} lg={6}
                                 className={`d-flex ${justifyContents(items).row_justify} m-0-auto w-100`}>
                                {items && items.map((item, i) => {
                                    const key = `item-${i}`, thumbnail = thumbnails[item['id']],
                                        linkViewImage = linksView[item['id']]
                                    if (item.type === 'google-folder') {
                                        return (
                                            <div key={key} className={"google-folder mx-1"}>
                                                <GoogleFolderElement
                                                    k={key}
                                                    item={item}
                                                    lang={lang}
                                                    iconsObject={{
                                                        googleFolderImgFull,
                                                        googleFolderImgEmpty,
                                                        googleFolderPublicEmptyIcon,
                                                        googleFolderPublicIcon,
                                                        img_context_menu_google
                                                    }}
                                                />
                                            </div>
                                        )
                                    }
                                    if (item.type === 'google-file') {
                                        item['thumbUrl'] = thumbnail || ''
                                        item['linkViewImage'] = linkViewImage || ''
                                        return (
                                            <div key={key} className={"google-file mx-1"}>
                                                <GoogleFileElement
                                                    k={key}
                                                    item={item}
                                                    l={l}
                                                    isGoogleDisc={isGoogleDisc}
                                                    isTrash={isTrash}
                                                    iconsObject={{
                                                        img_context_menu_google
                                                    }}
                                                />
                                            </div>
                                        )
                                    }

                                    if (item.type === 'folder') {
                                        return (
                                            <div key={key} className={"folder mx-1"}>
                                                <FolderElement
                                                    k={key}
                                                    auth={auth}
                                                    owner={owner}
                                                    item={item}
                                                    lang={lang}
                                                    iconsObject={{
                                                        folderImgFull,
                                                        folderImgEmpty,
                                                        folderPublicEmptyIcon,
                                                        folderPublicIcon,
                                                        img_context_menu
                                                    }}
                                                    documents={documents}
                                                />
                                            </div>
                                        )
                                    } else if (item.type === 'link') {
                                        return (
                                            <div key={key} className={"link mx-1"}>
                                                <LinkElement
                                                    k={key}
                                                    auth={auth}
                                                    owner={owner}
                                                    item={item}
                                                    documents={documents}
                                                />
                                            </div>
                                        )
                                    } else if (item.type === 'note') {
                                        return (
                                            <div key={key} className={"note mx-1"}>
                                                <NoteElement
                                                    k={key}
                                                    auth={auth}
                                                    l={l}
                                                    owner={owner}
                                                    item={item}
                                                    documents={documents}
                                                />
                                            </div>
                                        )
                                    } else {
                                        return (
                                            <div key={getRandomKey()}>
                                                <div className={"folder mx-1"}/>
                                            </div>
                                        )
                                    }
                                })}
                                {items && (items[0].type === 'google-folder' || items[0].type === 'google-file') && pageToken &&
                                <div className={'google-folder'}>
                                    <button style={{minHeight: '74px', minWidth: '74px'}}
                                            className={'btn btn-light border border-0 rounded-4'}
                                            onClick={loadMore}>
                                        <i className={"fa-solid fa-angles-right fs-2 text-black-50"}/>
                                    </button>
                                </div>
                                }
                            </Row>
                        </div>
                    </div>
                </div>
                {<MenuCreateItemPage documents={documents}/>}
            </>
        )
    }
}